import React from 'react';
import Topbar from './Topbar';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background">
      <Topbar />
      <main className="pt-16 max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16">
        {children}
      </main>
    </div>
  );
}